module.exports = __webpack_public_path__ + "static/media/triple-down-arrow.27d5131c.svg";